module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_komsco_m.bdc79b41b4ddbd3a8b3cdfed34ec1514.png";